import React from 'react';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { Row } from 'apps/auth/components/common/Layout/Row';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

const PickupDocsPopup = ({ popupRef, docsList }) => {
    const { pickupDocsTitle, pickupDocsBlock, gotIt } = usePageMessages;

    return (
        <>
            {docsList ? (
                <SimplePopup
                    text={
                        <>
                            <Row indent="24px">{docsList?.title}</Row>
                            <p>{MarkdownService.splitByParagraph(docsList.text)}</p>
                        </>
                    }
                    textAlign="left"
                    popupRef={popupRef}
                >
                    <PopupButton iconName="check" text={docsList?.continueButtonTitle} onClick={() => popupRef.current?.close()} />
                </SimplePopup>
            ) : (
                <SimplePopup
                    text={
                        <>
                            <Row indent="24px">{pickupDocsTitle}</Row>
                            <DangerouslyHtml dangerouslyHtml={pickupDocsBlock} />
                        </>
                    }
                    textAlign="left"
                    popupRef={popupRef}
                >
                    <PopupButton iconName="check" text={gotIt} onClick={() => popupRef.current?.close()} />
                </SimplePopup>
            )}
        </>
    );
};

export default PickupDocsPopup;
